import { render, staticRenderFns } from "./formItemGift.vue?vue&type=template&id=571919dc&scoped=true"
import script from "./formItemGift.vue?vue&type=script&lang=js"
export * from "./formItemGift.vue?vue&type=script&lang=js"
import style0 from "./formItemGift.vue?vue&type=style&index=0&id=571919dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571919dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('571919dc')) {
      api.createRecord('571919dc', component.options)
    } else {
      api.reload('571919dc', component.options)
    }
    module.hot.accept("./formItemGift.vue?vue&type=template&id=571919dc&scoped=true", function () {
      api.rerender('571919dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/publish/components/formItemGift.vue"
export default component.exports